export enum ActivityAvailabilityStatus {
    SOLD_OUT = 'SOLD_OUT',
    AVAILABLE = 'AVAILABLE',
    UNAVAILABLE = 'UNAVAILABLE',
}
